import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'demo-upp-time',
    templateUrl: './demo-upp-time.html',
    styleUrls: ['../demo-common.scss', './demo-upp-time.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppTimeComponent implements OnInit {
    form!: FormGroup;
    disabled = false;
    swipeEnabled = true;

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.form = new FormGroup({
            time: new FormControl('09:30')
        });
    }

    toggleDisabled(): void {
        this.disabled = !this.disabled;
        const control = this.form.get('time');
        if (this.disabled){
            control?.disable();
        }
        else {
            control?.enable();
        }
        this.change.markForCheck();
    }

    toggleSwipe(): void {
        this.swipeEnabled = !this.swipeEnabled;
        this.change.markForCheck();
    }
}
